import { defineMessages } from "react-intl";

export default defineMessages({
  bugreport: {
    id: "sidebar.bugreport"
  },
  categories: {
    id: "sidebar.categories"
  },
  folders: {
    id: "sidebar.folders"
  },
  generators: {
    id: "sidebar.generators"
  },
  logout: {
    id: "sidebar.logout"
  },
  settings: {
    id: "sidebar.settings"
  }
});



// WEBPACK FOOTER //
// ./src/Containers/Sidebar/translations.js